import React from 'react'
import {TodoList} from '@muchhadd/react-todo-list';
function Develop() {
    return (
        <div>
        <TodoList />
        </div>
    )
}

export default Develop;
